<template>
  <v-container fluid>
    <v-tabs center-active v-model="tabs" background-color="bg" slider-size="44" slider-color="primary" class="mt-3">
      <v-tab class="mb-1 ml-3 rounded-lg font-weight-bold text-caption text-sm-body-2 text-capitalize white elevation-2" :key="0"
        ><label style="cursor: pointer" class="custom_slider">Referral Dashboard </label></v-tab
      >
      <v-tab class="mb-1 ml-3 rounded-lg font-weight-bold text-caption text-sm-body-2 text-capitalize white elevation-2" :key="1"
        ><label style="cursor: pointer" class="custom_slider">Referral Received </label></v-tab
      >
      <v-tab class="mb-1 ml-3 rounded-lg font-weight-bold text-caption text-sm-body-2 text-capitalize white elevation-2 ms-4" :key="2"
        ><label style="cursor: pointer" class="custom_slider">Referral Used</label></v-tab
      >
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item :key="0">
        <ReferralDashboard />
      </v-tab-item>
      <v-tab-item :key="1">
        <ReferralCredit />
      </v-tab-item>
      <v-tab-item :key="2">
        <ReferralDebit />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import ReferralDebit from "../components/ReferralDebit.vue";
import ReferralCredit from "../components/ReferralCredit.vue";
import ReferralDashboard from "../components/ReferralDashboard.vue";
export default {
  components: { ReferralCredit, ReferralDebit, ReferralDashboard },
  created() {
    if (!this.hasRole(this.AdminUserPermissions.REFERRAL_VIEW)) {
      this.$router.push({
        name: "Error404",
      });
    }
  },

  methods: {},
  data() {
    return {
      tabs: 0,
    };
  },
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
.custom_slider {
  z-index: 1 !important;
}

.v-tabs-slider {
  border-radius: 7px;
  margin-top: -3px;
}
</style>
